import React from 'react';
import Card from 'react-bootstrap/Card';
import Fade from 'react-bootstrap/Fade';
import IconButton from '../../components/common/IconButton';
import moment from 'moment';
import axios from 'axios';
import AxiosConfig from '../../utilities/AxiosConfig';
import ErrorAlert from '../common/ErrorAlert';

interface ReferenceItem {
    FieldTimeCodeID: number;
    CodeDescription: string;
    HRTimeCodeId: number;
    DepartmentID: number;
    IsUserEditable: number;
    CreatedBy: number;
    CreatedDate: Date | string | null;
    DeletedBy: string | number | null;
    DeletedDate: Date | string | null;
    DisabledBy: number | null;
    DisabledDate: Date | string | null;
    HelpText: string | null;
    IsAdminEditable: boolean;
    IsNonNumericEntryOnly: boolean;
    IsProductivePay: boolean;
    ListOrder: number;
    ModifiedBy: number;
    ModifyDate: Date | string | null;
    NonNumericCharacterCsv: any;
    PayrollHRTimeCodeID: number;
}

interface AddRequestBody {
    EntryDate: Date | string | null;
    Quantity: number;
    DepartmentID: number;
    FieldTimeCodeID: number;
    EmployeeID: number;
    EnteredFieldTimeCodeID: number | null;
}

interface Entry {
    TimeEntryID: Number,
    EntryDate: string,
    Quantity: number,
    FieldTimeCodeID: number,
    ApprovedDate: string | null,
}

interface IProps {
    reference: any;
    selected: Entry | any;
    date: string;
    editCallback?: Function;
    employeeId: string;
    profitCenterId: string | number;
    handleChangesCallback: Function;
    clearEditsCallback: Function;
    isPreview?: boolean;
    noData?: boolean;
    regularHoursId: any;
    clickCallback? : Function;
    toggleDirty?: Function;
    validationMessages?: Array<string>;
    updateTimesheet?: Function;
    testid?: string;
}

const getApprovedFromGroup = (group: any, prefix: string = "border"): string => {
    let isApproved: boolean = true;
    let cn: string = "";
    if(group === undefined || group === null || group?.length === 0){
        isApproved = false;
        cn = prefix + "-dark"
        return cn;
    }
    // turn to reduce later
    group.forEach((entry: any) => {
        if(!entry.ApprovedDate) { //entry.Quantity !== 0 &&
            isApproved = false;
        }
    });
    if(isApproved){cn = prefix + "-darkgreen"}else{ cn = prefix + "-danger" }
    return cn;
}

const EntryCard: React.FC<IProps> = (props: IProps) => {
    const [saving, setSaving] = React.useState(false);
    const [error, setError] = React.useState("");
    const [original, setOriginal] = React.useState({} as any);
    const [edits, setEdits] = React.useState({} as any);
    const [isDirty, setIsDirty] = React.useState(false);
    const [fieldValues, setFieldValues] = React.useState({} as any);
    const { reference, selected, date, isPreview, noData } = props;
    let headerClassName: string = "";
    let approvedClassName: string = getApprovedFromGroup(selected, "border");
    if(approvedClassName !== "border-dark"){
        headerClassName = approvedClassName;
    }else{ headerClassName = "" }

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        e.preventDefault();
        if(e.target.value === ""){
            let editsCopy: any = {...edits};
            editsCopy[e.target.name] = 0;
            setEdits(editsCopy);
            checkIfDirty(editsCopy);
            let difference: number = -original[e.target.name];
            // //console.log(original, e.target.name);
            if(isNaN(difference)) {
                difference = 0;
            }
            // Getting difference
            let diff: number = 0;
            Object.keys(original).forEach((field: any) => {
                field = Number(field);
                let orig: any = original[field] || 0;
                // //console.log("First", editsCopy[field], orig, editsCopy[field] - orig)
                diff += (editsCopy[field] ? Number(editsCopy[field]) : 0) - orig;
            });
            // //console.log("Final Diff First ----->:: ", diff);
            props.editCallback&&props.editCallback(date, 0, diff);
            // //console.log("Final difference", difference);
        }
        if(checkNumber(e.target.value)){
            let editsCopy: any = {...edits};
            if(Number(e.target.value) > 24){ return; }
            editsCopy[e.target.name] = e.target.value || 0;
            setEdits(editsCopy);
            checkIfDirty(editsCopy);
            // Test
            let diff: number = 0;
            Object.keys(original).forEach((field: any) => {
                field = Number(field);
                let orig: number = original[field] || 0;
                if(field === Number(e.target.name)){
                    // //console.log( Number(e.target.value) - orig );
                    diff += Number(e.target.value) - orig;
                }
                else if(editsCopy[field] && field !== Number(e.target.name)){
                    // //console.log((editsCopy[field] ? Number(editsCopy[field]) : 0) - orig)
                    diff += (editsCopy[field] ? Number(editsCopy[field]) : 0) - orig;
                }
            });
            props.editCallback&&props.editCallback(date, e.target.value, diff);
            // //console.log("Final Diff Second ", diff);
            //End Test
        }
        let fieldValuesCopy: any = {...fieldValues};
        fieldValuesCopy[e.target.name] = e.target.value;
        setFieldValues(fieldValuesCopy);
    }

    const checkNumber = (num: any): any => !isNaN(parseFloat(num)) && isFinite(num)

    const checkIfDirty = (edits: any) => {
        // Compares each original and edit fields and returns true if one of them is different
        let editsKeys: Array<string> = Object.keys(edits);
        let originalKeys: Array<string> = Object.keys(original);
        // //console.log(original, edits);
        let dirty: boolean = false;
        if(editsKeys.length !== originalKeys.length){
            dirty = true;
        }
        editsKeys.forEach((key: any) => {
            // //console.log(Number(edits[key]))
            let edit: any = edits[key] === undefined ? undefined : Number(edits[key]);
            if(edit !== original[key]){
                // Sets dirty to true if values don't match
                dirty = true;
            }
        })
        setIsDirty(dirty);
        props.toggleDirty&&props.toggleDirty(dirty);
    }

    const handleSubmit = async() => {
        let totalHours: number = Object.values(edits).reduce((acc: number, val: any) => val ? acc += Number(val) : acc, 0);
        if(totalHours > 24){
            setError("No more than 24 hours on a selected day");
            return;
        }
        setSaving(true);
        let keys: Array<string> = Object.keys(edits);
        // Creating an array to hold axios requests
        let requestList: any = [];
        for(let i = 0; i < keys.length; i++){
            // Go through each field and send a request if it was changed
            let fieldId: string = keys[i];
            if(original[fieldId] !== edits[fieldId]){ // Checks if field has been changed
                if(original[fieldId] !== undefined){ // Updating the time entry if original object had any value not undefined
                    let originalEntry: any = props.selected.find((entry: any) => entry.FieldTimeCodeID === Number(fieldId));
                    let rb: any = {
                        ...originalEntry,
                        Quantity: Number(edits[fieldId]),
                        ModifiedBy: Number(props.employeeId),
                        ModifiedDate: moment().format()
                    };
                    if(rb.TimeEntryId || rb.FieldTimeCodeId){ delete rb.TimeEntryId; delete rb.FieldTimeCodeId; }
                    //console.log("Update Time Entry Request Body : ", rb);
                    let request: any = axios.post(`${process.env.REACT_APP_API_URL}/api/MyPortal/UpdateTimeEntry`, rb, AxiosConfig.configValue("min"))
                    requestList.push(request);
                }else{ // Adding a new entry
                    let rb: AddRequestBody = {
                        EntryDate: moment(props.date).format("YYYY-MM-DD") + "T00:00:00",//"YYYY-MM-DDT00:00:00",
                        Quantity: Number(edits[fieldId]),
                        DepartmentID: reference[0].DepartmentID, // Comes from reference object
                        FieldTimeCodeID: Number(fieldId),
                        EmployeeID: Number(props.employeeId),
                        EnteredFieldTimeCodeID: null,
                    }
                    //console.log("Add Time Sheet Request Body : ", rb);
                    let request: any = axios.post(`${process.env.REACT_APP_API_URL}/api/MyPortal/AddTimeEntry`, rb, AxiosConfig.configValue("min"));
                    requestList.push(request);
                }
            }
        }
        // Call all saved requests from above
        if(requestList.length > 0){
            axios.all(requestList)
            .then(axios.spread((...responses) => {
                //console.log(responses);
                // Creating handleChangesCallback object to update calendar
                let validationMessages: any = [];
                let resData: any = [];
                responses.forEach((res: any) => {
                    //console.log("SINGLE RESPONSE : ", res);
                    if(!res.data.Validation?.IsValid) { // Entry came back with validation messages
                        validationMessages.push(res.data.Validation.ValidationMessages[0].Item2);
                        if(res.data.ApprovedDate){
                            // Entry got approved while client was away
                            props.updateTimesheet&&props.updateTimesheet();
                        }
                    }else{ // Entry response came back fine pass to response array
                        let resBody = {
                            ...res.data,
                            EmployeeID: res.data.EmployeeId,
                            DepartmentID: res.data.DepartmentId,
                            TimeEntryID: res.data.TimeEntryId,
                            EntryDate: res.data.EntryDate,
                            Quantity: res.data.Quantity,
                            FieldTimeCodeID: res.data.FieldTimeCodeId,
                            ApprovedDate: res.data.ApprovedDate,
                        }
                        resData.push(resBody);
                    }
                });
                setIsDirty(false);
                // props.clearEditsCallback();
                // //console.log("Responses before : ", resData);
                // //console.log("Passing to edit", resData, validationMessages);
                setSaving(false);
                props.handleChangesCallback(resData, validationMessages);
            }))
            .catch((errors: any) => {
                //console.log(errors);
                setError("There was an error saving your entry.");
                setSaving(false);
            })
        }else{
            setSaving(false);
        }
    }

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        // Calls handleSubmit if the enter key is pressed in EntryCard inputs
        if(e.key === "Enter"){
            // if enter key is pressed attempt to submit value
            e.preventDefault();
            e.stopPropagation();
            handleSubmit();
            return;
        }
        // Checks if keycode typed is a period, backspace, or number
        if(e.keyCode !== 190 && e.keyCode !== 110 && e.keyCode !== 8 && !checkNumber(e.key)){
            e.preventDefault();
            e.stopPropagation();
            return false; 
        }
    }

    const handleDateChange = (e: React.SyntheticEvent) => { // handles click callback for preview cards
        e.preventDefault();
        if(props.isPreview) {
            props.clickCallback&&props.clickCallback();
        }
    }

    const focusField = (): boolean => {
        let toFocus: any = document.getElementById(`timesheet-input-${props.regularHoursId}`);
        toFocus && toFocus.focus();
        return toFocus ? true : false;
    }

    React.useEffect(() => { // Remaps values when selected date or reference gets changed
        let finalEdits: any = {};
        let finalFields: any = {};
        reference?.forEach((ref: ReferenceItem) => {
            let q: number = selected?.find((item: Entry) => item.FieldTimeCodeID === ref.FieldTimeCodeID)?.Quantity;
            finalEdits[ref.FieldTimeCodeID] = q;
            finalFields[ref.FieldTimeCodeID] = q;
        });
        setFieldValues(finalFields);
        setOriginal(finalEdits);
        setEdits(finalEdits);
    }, [selected, reference])

    React.useEffect(() => {
        focusField();
        return () => { props.clearEditsCallback(); };
        // eslint-disable-next-line 
    }, [])

    return (
        <>
        <Fade appear in={true}>
        <div
            data-testid={props.testid || ""}
            id={`timesheet-card-${date}`} 
            className={`w-100 ${isPreview ? "d-none d-lg-flex" : "d-flex"} justify-content-center align-items-center`}
        >
            <Card onClick={handleDateChange} className={`mr-2 shadow border-secondary pb-1 ${isPreview && "entrycard-preview"}`} style={{ maxHeight: window.innerWidth < 992 ? "450px" : "none", opacity: isPreview ? "0.75" : 1 }}>
                <Card.Header className={`text-center border border-width-2 ${headerClassName} ${!isPreview ? "primary-entry-card" : ""}`} as="h2">
                    {moment(date, "M/DD/YYYY").format("ddd MM/DD")}
                </Card.Header>
                <ErrorAlert onClose={() => setError("")} dismissible show={error.length > 0} message={error}><span>{error}</span></ErrorAlert>
                {props.validationMessages && 
                props.validationMessages?.map((mess: string, index: number) => 
                    <ErrorAlert className="mb-0" key={index} show={true}><span>{mess}</span></ErrorAlert>
                )}
                <Card.Body className="d-flex flex-column justify-content-center px-5 timesheet-entrycard-body">
                    {
                    reference.sort((a: ReferenceItem, b: ReferenceItem) => a.ListOrder - b.ListOrder).map((ref: any) => {
                        let s = selected?.find((item: Entry) => item.FieldTimeCodeID === ref.FieldTimeCodeID);
                        let isApproved = s ? s.ApprovedDate ? true : false : false;
                        if(ref.IsUserEditable && !isPreview){
                            return(
                            <div key={ref.FieldTimeCodeID} className="d-flex flex-column justify-content-center align-items-center">
                                {ref.ListOrder === 1 ? 
                                <h3>{ref.CodeDescription}</h3> : 
                                <h5>{ref.CodeDescription}</h5>}
                                <input
                                    id={isPreview ? "" : `timesheet-input-${ref.FieldTimeCodeID}`}
                                    className={`text-center border form-control ${isApproved ? "bg-darkgreen text-white" : s ? "bg-danger text-white" : original[ref.FieldTimeCodeID] ? "bg-danger text-white" : ""}`} 
                                    style={ref.ListOrder === 1 ? {height: 50, maxWidth: 100, fontSize: 30} : {maxWidth: 60, height: 30}} 
                                    value={(typeof fieldValues[ref.FieldTimeCodeID] === "string" || typeof fieldValues[ref.FieldTimeCodeID] === "number") ? fieldValues[ref.FieldTimeCodeID] : ""} 
                                    type={ref.IsUserEditable ? "text" : "number"}
                                    name={ref.FieldTimeCodeID}
                                    readOnly={!ref.IsUserEditable || isApproved}
                                    onChange={handleChange}
                                    onKeyDown={handleKeyDown}
                                    min={0}
                                    max={24}
                                />
                            </div>)
                        }else{
                            return(
                            <div key={ref.FieldTimeCodeID} className="d-flex flex-column justify-content-center align-items-center">
                                <h5>{ref.CodeDescription}</h5>
                                <span style={ref.ListOrder === 1 ? {width: 100, height: 50, fontSize: 30} : {width: 60, height: 30}} className={`border px-2 py-1 text-center ${isApproved ? "text-darkgreen bg-lightgrey" : s?.Quantity ? "" : "text-dark bg-lightgrey"}`}>
                                    {noData ? "NA" : edits[ref.FieldTimeCodeID] || 0}
                                </span>
                            </div>)
                        }
                    })
                    }
                </Card.Body>
                {!isPreview && <IconButton disabled={!isDirty || saving} showSpinner={saving} onClick={handleSubmit} buttonClassName="mx-auto mb-1 btn-outline-secondary mt-1" icon="save">Save</IconButton>}
            </Card>
        </div>
        </Fade>
        </>
    );
}

EntryCard.defaultProps = {
    isPreview: false,
    noData: false
}

export default EntryCard;